import './App.css';
import { TodoWrapper } from './components/TodoWrapper';
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    document.title = 'ToDoList App';
    return () => {
      document.title = 'ToDoList';
    };
  }, []);

  return (
    <div className="App">
      <TodoWrapper  />
    </div>
  );
}

export default App;
